import React, { Component } from 'react';
import Logo from './Logo';
import EqualHousingOpportunity from './EqualHousingOpportunity';

export class Lost extends Component {
    static displayName = Error.name;

    constructor(props) {
        super(props);
        this.state = { };
    }

    componentDidMount() {

    }

    render() {

        return (
            <div>
                <div class="wrapper">
                    <Logo/>
                    <div class="content">
                        <h1>Looks like you might be lost</h1>
                        <h2 class="">You can always give us a call for directions ;)<br />
                            <span><a href="tel:1-877-846-4968">1-877-846-4968</a></span></h2>
                            <a href="https://www.uhm.com">
                                <button class="button">Take me home</button>
                            </a>
                    </div>
                    <div class="footer">
                        <img src="https://www.uhm.com/images/uhm/uhm-logo-color.svg" alt="Union Home Mortgage logo" />
                        <EqualHousingOpportunity />
                    </div>
                </div>
                <div class="homeImg"></div>
            </div>
        );
    }
}
